import React, { FC, useCallback, useEffect } from 'react';
import ExerciseFormContent from './ExerciseFormContent';
import { ExerciseFormInitialValues, ExerciseFormMode, ExerciseFormType } from '../../../types';
import { useAppDispatch, useAppSelector } from '../../../../shared/hooks/useAppDispatch';
import { patchBlock } from '../../../../shared/slices/blocks/api/blocks';
import { useTranslation } from 'react-i18next';

type Props = {
  seriesId: string;
  exerciseId: string;
  bookId: string;
  onUpdateExercise: () => void;
  onCancel: () => void;
  mode: ExerciseFormMode;
  type: ExerciseFormType;
  initialValues: ExerciseFormInitialValues;
};

export interface UpdateBlock extends ExerciseFormInitialValues {
  type: ExerciseFormType;
}

const UpdateExerciseForm: FC<Props> = ({
  seriesId,
  exerciseId,
  bookId,
  onUpdateExercise,
  onCancel,
  mode,
  type,
  initialValues,
}) => {
  const dispatch = useAppDispatch();
  const error = useAppSelector((state) => state.blocks.error);
  const success = useAppSelector((state) => state.blocks.success);
  const { t } = useTranslation();

  useEffect(() => {
    if (success) {
      onUpdateExercise();
    }
  }, [onUpdateExercise, success]);

  const handleSubmit = useCallback(
    (values: UpdateBlock) => {
      dispatch(
        patchBlock({
          bookId: bookId!,
          pageId: seriesId,
          blockId: exerciseId,
          payload: {
            title: values.title || null,
            level: String(values.level),
            bloom_type: values.bloom_type,
            type: values.type,
            algebra_kit_exercise_id: values.algebra_kit_exercise_id,
            exercise_tool: values.exercise_tool === '1' ? null : values.exercise_tool,
            description: values.description ?? '',
          },
        })
      );
    },
    [dispatch, bookId, exerciseId, seriesId]
  );

  return (
    <ExerciseFormContent
      mode={mode}
      type={type}
      onSubmit={handleSubmit}
      onCancel={onCancel}
      error={error ? t('shared.errors.generic') : undefined}
      initialValues={initialValues}
    />
  );
};

export default UpdateExerciseForm;
